<template>
    <div>
        <input type="file" ref="file" style="display: none" @change="fileUpload()">
        <button v-if="!file" class="button" v-on:click="getFile" :type="type">
            <span v-if="text!=null">{{text}}</span>
            <img v-if="front_arrow" class="arrow" :alt="text" src="../assets/front-arrow-white.svg"/>
        </button>
        <span v-if="file">{{file.name}}</span>
    </div>
</template>

<script>
export default {
    name: "ButtonPrimary",
    data (){
        return {
            file: null,

        }
    },
    props: {
        text: String,
        front_arrow: {
            type: Boolean,
            default: false,
        },
        file_input: {
            type: Boolean,
            default: false
        },
        type: String
    },
    methods: {
        getFile: function (evt) {
            if (this.file_input) {
                evt.preventDefault();
                this.$refs.file.click()
            }
        },
        fileUpload: function(){
            this.file = this.$refs.file.files[0];
            this.$emit('fileUpload', this.$refs.file.files[0]);
        },
        

    }
}
</script>

<style scoped>
    .button{
        background-color: #6ABF67;
        color: #ffffff;
        text-align: center;
        align-items: center;
        /* height: -webkit-fill-available; */
        height: 100%;
        width: 100%;
        border: 2px solid #6dab6b;
        float:left;
    }

    .arrow {
        width: 20px;
    }
</style>